import FieldFile from "@local/components/field-file";
import FieldGroup from "@local/components/field-group";
import FieldSelect from "@local/components/field-select";
import Modal from "@local/components/modal";
import { reduxForm, Field } from "redux-form";
import { isNumeric, isRequired, isValidDate } from "@local/utils/validators";
import FieldText from "@local/components/field-text";
import FieldDatePicker from "@local/components/field-date-picker";
import FieldDateRangePicker from "@local/components/field-date-range-picker";
import Button from "@local/components/button";
import ConfirmModal from "@local/components/confirm-modal";
import { useState } from "react";
import { connect } from "react-redux";
import FieldSingleSelectSearch from "@local/components/field-single-search-select";
import i18n from "@local/i18next/i18n";
import FieldRadioGroup from "@local/components/field-radio-group";
const AddAuditModal = ({ isOpen, onClose, formValues, onAuditSubmit, countries, invalid }) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={i18n.t("Add Audit Report")}
        footer={
          <>
            <Button text={"Cancel"} onClick={onClose} />
            <Button isDisabled={invalid} text={"Submit"} onClick={() => setIsConfirmOpen(true)} />
          </>
        }
      >
        <FieldGroup>
          <div>
            <Field
              component={FieldRadioGroup}
              validate={[isRequired]}
              small
              fullWidthLabel
              id="type"
              name="type"
              label={i18n.t("Type")}
              placeholder={i18n.t("Type")}
              options={[
                {
                  value: "audit",
                  label: "Audit",
                },
                {
                  value: "spot_check",
                  label: "Spot Check",
                },
              ]}
            />
            {formValues?.["type"] === undefined ? <span style={{ color: "#d32f2f", fontSize: "12px", paddingLeft: ".8rem" }}>{"This field is required"}</span> : undefined}
          </div>
          <Field component={FieldText} validate={[isRequired]} id="report_name" name="report_name" label={i18n.t("Report Name")} placeholder={i18n.t("Report Name")} />
          <Field component={FieldText} validate={[isRequired]} id="report_type" name="report_type" label={i18n.t("Report Type")} placeholder={i18n.t("Report Type")} />

          <Field component={FieldSingleSelectSearch} validate={[isRequired]} id="operating_country" name="operating_country" label={i18n.t("Operation Country")} placeholder={i18n.t("Operation Country")} valueField="value" labelField="label" options={countries} />
          <Field
            component={FieldSelect}
            validate={[isRequired]}
            id="opinion"
            name="opinion"
            label={i18n.t("Opinion")}
            placeholder={i18n.t("Opinion")}
            valueField="value"
            labelField="label"
            options={[
              { label: "Adverse", value: "adverse" },
              { label: "Disclaimer", value: "disclaimer" },
              { label: "Unmodified", value: "unmodified" },
              { label: "Qualified", value: "qualified" },
              { label: "Unqualified", value: "unqualified" },
              { label: "Not Applicable", value: "not_applicable" },
            ]}
          />
          <Field component={FieldDatePicker} validate={[isRequired, isValidDate]} maximumDate={new Date()} id="audit_date" name="audit_date" label={i18n.t("Report Issue Date")} placeholder={i18n.t("Report Issue Date")} />
          <Field
            component={FieldDateRangePicker}
            //   minimumDate={new Date()}
            validate={[isRequired]}
            id="audit_date_period"
            name="audit_date_period"
            label={i18n.t("Coverage Date")}
            placeholder={i18n.t("Coverage Date")}
          />
          <Field component={FieldText} id="key_findings" name="key_findings" label={i18n.t("Key Findings")} placeholder={i18n.t("Key Findings")} />
          <Field component={FieldText} id="recommendations" name="recommendations" label={i18n.t("Recommendations")} placeholder={i18n.t("Recommendations")} />
          <Field component={FieldText} validate={[isNumeric]} id="ineligible_expenses" name="ineligible_expenses" label={i18n.t("Ineligible Expenses")} placeholder={i18n.t("Ineligible Expenses")} />
          <Field validate={[isRequired]} multiple={true} component={FieldFile} id="attachments" name="attachments" label={i18n.t("Attachments")} placeholder={i18n.t("Attachments")} readOnly={false} />
        </FieldGroup>
      </Modal>
      <ConfirmModal
        isOpen={isConfirmOpen}
        onSubmit={async () => {
          await onAuditSubmit(formValues);
          setIsConfirmOpen(false);
        }}
        onClose={() => setIsConfirmOpen(false)}
        title={i18n.t("Add Audit Report")}
        message={i18n.t("Do you confirm adding this audit report?")}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.form?.addAuditModalForm?.values,
});

export default connect(mapStateToProps)(reduxForm({ form: "addAuditModalForm", enableReinitialize: true })(AddAuditModal));
